import styled from '@emotion/styled'

export const Cell = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const TableContainer = styled.div`
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    padding: 12px 8px;
  }
`

export const WrappText = styled.span`
  display: inline-block;
  text-wrap: wrap;
  word-break: break-all;
  width: 100%;
`
